exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-header-row{position:sticky;top:0;z-index:100;background-color:#000;width:100%;padding-top:16px;padding-bottom:5px}.edit-profile-modal-title{padding-left:7rem}@media(max-width: 767px){.edit-profile-modal-title{padding-left:1rem;text-align:left}.edit-profile-header{padding-left:0 !important;text-align:left}.edit-profile-header-cancel-btn{width:45%}.save-btn{width:45%}#edit-profile-modal .col-1{flex:0 0 auto;width:auto;max-width:none}#edit-profile-modal .img-upload-form-col{flex:0 0 100%;max-width:100%;margin-bottom:1rem}#edit-profile-modal .form-row>.col-7{flex:0 0 100%;max-width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/EditProfileForm/styles.scss
// module id = 771
// module chunks = 0